import classNames from 'classnames'
import React from 'react'

import Data from 'data'

import { getAssetsPath } from 'common'

export function SmallIcon({
  className,
  style,
  icon,
  ...props
}: {
  icon: string | undefined
} & React.HTMLAttributes<HTMLSpanElement>) {
  if (!icon) return null
  const parts = icon.split('/')
  const name = parts.pop()!
  const index = Data.iconMap[parts.join('/')]?.[name]
  if (index == null) return null
  const x = index % 16,
    y = Math.floor(index / 16)
  return (
    <span
      className={classNames('poe-small-icon', className)}
      style={{
        backgroundImage: `url(${getAssetsPath(`items/${parts.join('.')}.webp`)})`,
        backgroundPosition: `-${x * 24}px -${y * 24}px`,
        ...style
      }}
      {...props}
    />
  )
}

export function CopyIcon({ className, ...props }: React.SVGAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      className={classNames(className, 'd4t-svg-inline')}
      width="17"
      height="11"
      viewBox="0 0 17 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="5.23438"
        y="8.49121"
        width="1.4"
        height="6"
        rx="0.7"
        transform="rotate(135 5.23438 8.49121)"
        fill="currentColor"
      />
      <rect
        width="1.4"
        height="6"
        rx="0.7"
        transform="matrix(0.707107 0.707107 0.707107 -0.707107 11 8.49121)"
        fill="currentColor"
      />
      <rect x="4.24609" y="1" width="1.4" height="6" rx="0.7" transform="rotate(45 4.24609 1)" fill="currentColor" />
      <rect
        width="1.4"
        height="6"
        rx="0.7"
        transform="matrix(-0.707107 0.707107 0.707107 0.707107 11.9883 1)"
        fill="currentColor"
      />
      <rect x="8.58984" width="1.4" height="10" rx="0.7" transform="rotate(15 8.58984 0)" fill="currentColor" />
    </svg>
  )
}

export function EditIcon({ className, ...props }: React.SVGAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      className={classNames(className, 'd4t-svg-inline')}
      width="9"
      height="10"
      viewBox="0 0 9 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 7.72487V9.59961H1.87474L7.173 4.30135L5.29826 2.42661L0 7.72487ZM8.85377 2.62058C9.04874 2.42561 9.04874 2.11065 8.85377 1.91568L7.68393 0.745839C7.48896 0.550866 7.174 0.550866 6.97903 0.745839L6.06416 1.66071L7.9389 3.53545L8.85377 2.62058Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function ExpandIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="10" height="10" {...props} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 2.7373V1.20116 M7.46094 1.20117H8.99709"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M2.53906 1.19922H1.00291 M1.00781 2.73535V1.1992"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M7.46094 9.20117H8.99709 M8.99219 7.66504V9.20119"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M1 7.66504V9.20119 M2.53906 9.20117H1.00291"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  )
}
